import React from "react";
import { Check } from "lucide-react";
import { BUNDLE_OPTIONS } from "@/data/catalog";
import { formatPrice } from "@/lib/format";
import { useCart } from "@/context/CartContext";
import { SectionHeading } from "@/components/home/SectionHeading";

export const BundleBuilder = () => {
  const { addItem } = useCart();

  return (
    <section id="bundle-builder" className="bg-[#E9E2D6]/50 py-16 md:py-24" data-testid="bundle-builder">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          overline="Bundle builder"
          title="Build your bundle, save more"
          subtitle="Mix and match patches and balm. The more you bundle, the more you save."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {BUNDLE_OPTIONS.map((b) => {
            const saving = b.compareAt ? b.compareAt - b.price : 0;
            return (
              <div
                key={b.id}
                data-testid={`bundle-${b.id}`}
                className={`relative bg-white rounded-3xl p-6 flex flex-col gap-5 shadow-[0_4px_24px_rgba(111,80,58,0.05)] border-2 transition-colors ${
                  b.popular ? "border-[#B8C4A3]" : "border-transparent"
                }`}
              >
                {b.popular && (
                  <span className="absolute -top-3 left-6 px-3 py-1 rounded-full bg-[#B8C4A3] text-white text-xs font-semibold">
                    Most popular
                  </span>
                )}
                <div className="aspect-[5/3] rounded-2xl bg-[#F8F5EF] overflow-hidden">
                  <img src={b.image} alt={b.name} loading="lazy" className="w-full h-full object-contain p-3" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-[#6F503A]">{b.name}</h3>
                  <p className="text-sm text-[#6F503A]/60">{b.detail}</p>
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-heading text-xl font-semibold text-[#6F503A]">{formatPrice(b.price)}</span>
                  {b.compareAt && (
                    <>
                      <span className="text-sm text-[#6F503A]/40 line-through">{formatPrice(b.compareAt)}</span>
                      <span className="ml-auto inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#B8C4A3]/25 text-[#6F503A] text-xs font-semibold">
                        <Check className="w-3 h-3" /> Save {formatPrice(saving)}
                      </span>
                    </>
                  )}
                </div>
                <button
                  data-testid={`add-bundle-${b.id}`}
                  onClick={() =>
                    addItem(
                      { id: `bundle-${b.id}`, name: b.name, image: b.image, price: b.price, compareAt: b.compareAt },
                      { qty: 1, sellingPlan: "onetime" }
                    )
                  }
                  className="mt-auto w-full py-3 rounded-full bg-[#6F503A] text-[#F8F5EF] font-medium hover:bg-[#5b4130] transition-colors"
                >
                  Add to Cart
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
